const formValidation = {
  'formValidation.minLength': 'This field requires at least {min} character(s)',
  'formValidation.maxLength': 'This field allows {max} character(s) at most',
  'formValidation.required': 'This field is required',
  'formValidation.emailInvalid': 'Invalid email address',
  'formValidation.phoneInvalid': 'Invalid phone number',
  'formValidation.phoneCount': 'You can add up to {max} phone numbers',
  'formValidation.minValue': 'The minimum value is {min}',
  'formValidation.lengthAtLeast':
    'This field requires at least {arg} character(s)',
  'formValidation.shouldContain-upperCase':
    'This field requires at least one uppercase character',
  'formValidation.shouldContain-lowerCase':
    'This field requires at least one lowercase character',
  'formValidation.shouldContain-numbers':
    'This field requires at least one numeric character',
  'formValidation.shouldContain-specialCharacters':
    'This field requires at least one special character',
  'formValidation.password-dont-match':
    'Confirmation password must match the new password.',
  'formValidation.password-requirements':
    'Your new password must be at least 8 characters long, containing at least one lowercase character, one uppercase character, one number and one special character.',
};

export default formValidation;
